import { selectedProjectAtom } from '@js/store/appAtoms';
import { PagePath } from '@routing/appUrls';
import { useAtom } from '@store';
import { ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router';

type Props = {
    children: ReactNode;
};

const ProjectContextRoute = ({ children }: Props) => {
    const navigate = useNavigate();
    const [selectedProject] = useAtom(selectedProjectAtom);

    useEffect(() => {
        if (!selectedProject?.projectId) {
            navigate(PagePath.selectProject);
        }
    }, []);

    return <>{children}</>;
};

export default ProjectContextRoute;
